import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocApiKeyManagementRoute: InvariantJiraRoute = {
	name: 'eoc-api-key-management',
	path: '/jira/settings/products/ops/api-key-management',
	exact: true,
};
